export enum Permission {
  LegacyAdmin = 'admin_panel.legacy_permission',
  ReadOnly = 'revoke_writes.legacy_permission',
  StoreConfigsView = 'store_configs.view',
  StoreConfigsModify = 'store_configs.modify',
  SiteManagementStorefrontNavigationView = 'site_management_storefront_navigation.view',
}
